export default __webpack_public_path__ + "static/media/nominee_icon.f14d10f4.svg";